import enUS from './en-US.json';
import { Locale } from './types';

export const locales = {
  [Locale.en]: enUS,
};
